import { collectEvent, UserAction, userActionTypeEnum, } from '@thoughtspot/metrics';
import { getProductType } from '@thoughtspot/session-service';
const commonProps = () => ({
    timestamp: Date.now(),
    productType: getProductType(),
    source: 'ui',
});
export const trackVariableCreate = (success, props) => {
    collectEvent(new UserAction(success
        ? userActionTypeEnum.VARIABLE_CREATE_SUCCESS
        : userActionTypeEnum.VARIABLE_CREATE_FAILURE), { ...commonProps(), ...props });
};
export const trackVariableEdit = (success, props) => {
    collectEvent(new UserAction(success
        ? userActionTypeEnum.VARIABLE_EDIT_SUCCESS
        : userActionTypeEnum.VARIABLE_EDIT_FAILURE), { ...commonProps(), ...props });
};
export const trackVariableDelete = (success, props) => {
    collectEvent(new UserAction(success
        ? userActionTypeEnum.VARIABLE_DELETE_SUCCESS
        : userActionTypeEnum.VARIABLE_DELETE_FAILURE), { ...commonProps(), ...props });
};
export const trackVariableRename = (success, errorCode) => {
    collectEvent(new UserAction(success
        ? userActionTypeEnum.VARIABLE_RENAME_SUCCESS
        : userActionTypeEnum.VARIABLE_RENAME_FAILURE), { ...commonProps(), errorCode });
};
export const trackVariablePageVisited = () => {
    collectEvent(new UserAction(userActionTypeEnum.VARIABLE_PAGE_VISITED), {
        ...commonProps(),
    });
};
export const trackVariableCreateAbandoned = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.VARIABLE_CREATE_ABANDONED), {
        ...commonProps(),
        ...props,
    });
};
//# sourceMappingURL=variables-analytics.js.map